import { render, staticRenderFns } from "./page-core-data.vue?vue&type=template&id=1332b1ee&scoped=true"
import script from "./page-core-data.vue?vue&type=script&lang=js"
export * from "./page-core-data.vue?vue&type=script&lang=js"
import style0 from "./page-core-data.vue?vue&type=style&index=0&id=1332b1ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332b1ee",
  null
  
)

export default component.exports